import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashItemTractComponent } from './dash-item-tract/dash-item-tract.component';
import { DashItemExampleComponent } from './dash-item-example/dash-item-example.component';
import { DashItemBackupComponent } from './dash-item-backup/dash-item-backup.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { DashItemAggregateStateComponent } from './dash-item-aggregate-state/dash-item-aggregate-state.component';
import { SharedComponentsModule } from '../shared/components/shared-components.module';

@NgModule({
  declarations: [ DashItemTractComponent, DashItemExampleComponent, DashItemAggregateStateComponent, DashItemBackupComponent ],
  imports: [
    CommonModule,
    HighchartsChartModule,
    SharedComponentsModule,
  ],
  exports: [ DashItemTractComponent, DashItemExampleComponent, DashItemAggregateStateComponent, DashItemBackupComponent ]
})

export class LandingModule { }
